import Link from "next/link"
import Image from "next/image"
import { siteConfig,} from "@/lib/data"
import { FaInstagram, FaFacebook,  FaEnvelope, FaPhoneAlt,FaMapMarkerAlt} from "react-icons/fa"
import { FaXTwitter,FaYoutube } from "react-icons/fa6";

export default function Footer() {
  return (
    <footer className="w-full border-t border-white/5 bg-zinc-950 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        {/* TOP SECTION: Widgets Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Widget 1: Brand & Bio */}
          <div className="col-span-1 md:col-span-1">
               <Link href="/" className="block mb-6">
          <Image 
            src="/mk2.png"
            alt="Modish Kreations Logo"
            width={100}   
            height={50}
            className="object-contain"
            priority
          />
        </Link>
            <Link href="/" className="text-xl font-bold tracking-tighter text-white">
              {siteConfig.name.split(' ')[0]}<span className="text-[#C7AB5F]">{siteConfig.name.split(' ')[1]}</span>
            </Link>
            <p className="mt-4 text-sm text-zinc-400 leading-relaxed">
            </p>
            {/* Social Icons */}
            <div className="flex gap-4 mt-6">

            <a href="https://www.instagram.com/modishkreations_/" target="_blank" className=" text-zinc-300 hover:text-pink-500 transition-all text-2xl">
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/profile.php?id=100089992603615" target="_blank" className="text-zinc-300 hover:text-blue-600 transition-all text-2xl">
                <FaFacebook />
              </a>
              <a href="#" target="_blank" className="text-zinc-300 hover:text-red-600 transition-all text-2xl">
                <FaYoutube />
              </a>
              <a 
                  href="#" 
                  target="_blank" 
                   className="text-zinc-300 hover:text-sky-400 transition-all text-2xl"
                   >
                     <FaXTwitter />
              </a>
            </div>
          </div>

          {/* Widget 2: Navigation */}
          <div>
            <h3 className="text-white font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link href="/" className="hover:text-[#C7AB5F] transition-colors">Home</Link></li>
              <li><Link href="/about" className="hover:text-[#C7AB5F] transition-colors">About Us</Link></li>
              <li><Link href="/career" className="hover:text-[#C7AB5F] transition-colors">Join Us</Link></li>
              <li><Link href="/contact" className="hover:text-[#C7AB5F] transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Widget 3:Quick Links   */}
          <div>
            <h3 className="text-white font-semibold mb-4"> Quick Links</h3>
            <ul className="space-y-2 text-sm text-zinc-400">
               <li><Link href="/privacy" className="hover:text-[#C7AB5F] transition-colors">Privacy Policy</Link></li>
              <li><Link href="/terms" className="hover:text-[#C7AB5F] transition-colors">Terms & Conditions</Link></li>
              <li><Link href="/disclaimer" className="hover:text-[#C7AB5F] transition-colors">Disclaimer</Link></li>
              <li><Link href="/return" className="hover:text-[#C7AB5F] transition-colors">Return & Cancellation Policy</Link></li>
              <li><Link href="/shipping" className="hover:text-[#C7AB5F] transition-colors">Shipping Policy</Link></li>
            </ul>
          </div>

          {/* Widget 4: Newsletter / Contact */}
          <div>
          <h3 className="text-white font-semibold mb-4">Get in Touch</h3>
          <p className="text-sm text-zinc-400 mb-4"></p>
          
          <ul className="space-y-3"> {/* space-y-3 se lines ke beech gap aa jayega */}
            
            {/* Email Item */}
            <li>
              <a 
                href={`mailto:${siteConfig.email}`} 
                className="inline-flex items-center gap-2 text-sm font-medium text-white hover:text-[#C7AB5F] transition-colors"
              >
                <FaEnvelope size={16} /> {siteConfig.email}
              </a>
            </li>

            {/* Phone Item */}
            <li>
              <a 
                href={`tel:${siteConfig.phone}`} 
                className="inline-flex items-center gap-2 text-sm font-medium text-white hover:text-[#C7AB5F] transition-colors"
              >
                <FaPhoneAlt size={16} /> {siteConfig.phone}
              </a>
            </li>
            {/* Address Item  */}
            <li className="inline-flex items-start gap-2 text-sm text-white">
              <FaMapMarkerAlt size={35} className="mt-0.5" /> 
              <span>{siteConfig.address}</span>
            </li>
          </ul>
        </div>

        </div>

        {/* BOTTOM SECTION: Copyright */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white">
            © {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <p className="text-xs text-white flex items-center gap-1">
            Build with <span className="text-red-500">♥</span> by <span className="font-medium text-white">Bizjunket</span>
          </p>
        </div>

      </div>
    </footer>
  )
}